import { Component, OnInit, Input } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {LeftpanelComponent, LoaderWithProgressComponent} from '../leftpanel/leftpanel.component';
import {KongService} from '../kong.service';
import {interval} from 'rxjs';
import {MatDialog} from '@angular/material';
import {environment} from 'src/environments/environment';

@Component({
  selector: 'app-apiql-engine',
  templateUrl: './apiql-engine.component.html',
  styleUrls: ['./apiql-engine.component.scss']
})
export class ApiqlEngineComponent implements OnInit {

  tabData: any;
  activeTabIndex: any;
  showDoc = false;
  paramsTobeSent: any;

  componentLoading = true;
  gatewayUrlDeploying = false;
  gatewayUrlExists = false;

  defaultGatewayHost: string;
  // this.kong.getServicesFromApiGatewayByNameOrIdWithHost(this.defaultGatewayHost,

  @Input() partner = localStorage.getItem('partner');
  @Input() account = localStorage.getItem('account');

  apiQlApiName = 'apiql';
  apiQlApiVersion = 'v1';

  executor = {
    partner: localStorage.getItem('partner'),
    account_id: localStorage.getItem('partner'),
    executor_method_type: 'POST',
    apiUrl: '',
    dataroot: null,
    queryParams: [
      {
        'key': 'dbref',
        'value': 'false',
        'description': '',
        'req': false
      },
      {
        'key': 'limit',
        'value': '1000',
        'description': '',
        'req': false
      },
      {
        'key': 'offset',
        'value': '0',
        'description': '',
        'req': false
      },
      {
        'key': 'pagination',
        'value': 'false',
        'description': '',
        'req': false
      },
      {
        'key': 'self-links',
        'value': 'false',
        'description': '',
        'req': false
      },
      {
        'key': 'sort',
        'value': '',
        'description': '',
        'req': false
      }
    ],
    pathParams: [],
    headers: [
      {
        'key': 'Content-Type',
        'value': 'text/plain',
        'description': '',
        'req': false
      },
      {
        'key': 'apikey',
        'value': localStorage.getItem('apikey'),
        'description': '',
        'req': false
      },
      {
        'key': 'pkey',
        'value': localStorage.getItem('partnerKey'),
        'description': '',
        'req': false
      },
      {
        'key': 'partner',
        'value': localStorage.getItem('partner'),
        'description': '',
        'req': false
      }
    ],
    'requestBody': {
      'value': '',
      'key': 'payload',
      'description': 'Document in APIQL format',
      'annotation': 'RequestBody'
    },
    prerequisites: null,
    authModel: {
      'authAttributes': {}
    }
  };

  constructor(public route: ActivatedRoute,
              public platform: LeftpanelComponent,
              private kong: KongService,
              private router: Router,
              private dialog: MatDialog) {
  }

  async ngOnInit() {

    if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
      this.platform.initialisePlatform();
    }

    this.defaultGatewayHost = await this.kong.getDefaultGatewayURL();

    this.executor.apiUrl = 'https://' + this.defaultGatewayHost + '/' + this.apiQlApiVersion + '/' + this.apiQlApiName;

    const permissionSubscription = interval(500).subscribe((async x => {
      permissionSubscription.unsubscribe();
      this.tabData = [];
      this.route.queryParams.subscribe(params => {
        if (params) {
          if (params.showDoc) {
            this.paramsTobeSent = params;
            this.showDoc = true;
          } else {
            this.addTab(params);
            this.showDoc = false;
          }
        }
      });

      Promise.resolve(this.checkIfGatewayURLExists().then(response => {
        this.gatewayUrlExists = true;
        this.componentLoading = false;
      }, error => {
        this.gatewayUrlExists = false;
        this.componentLoading = false;
      }));
    }));
  }

  addTab(params = {}) {
    this.tabData.push({method: '', apiUrl: '', params: params});
    this.activeTabIndex = this.tabData.length - 1;
  }

  closeTab(index) {
    this.tabData.splice(index, 1);
    this.activeTabIndex = this.tabData.length - 1;
  }

  tabNameChanged(tabName, index) {
    this.tabData[index].method = tabName.method;
    this.tabData[index].apiUrl = tabName.apiUrl;
  }

  checkIfGatewayURLExists() {
    return new Promise((resolve, reject) => {
      this.kong.getServicesFromApiGatewayByNameOrId(this.partner + '-' + this.account + '-' + this.apiQlApiName + '-' + this.apiQlApiVersion).subscribe(gatewayService => {
        if (gatewayService) {
          resolve('success');
        } else {
          reject('failed');
        }
      }, error => {
        if (error.status === 404) {
          reject(error);
        } else {
          this.platform.openSnackBar('Error while loading the APIQL Engine. Please try again after sometime.', 'Error', {
            duration: 7000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
          this.router.navigateByUrl('/controlplane');
          resolve('failed');
        }
      });
    });
  }

  async setupGatewayForAPIQLEngine() {
    const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
      maxWidth: '135vw',
      maxHeight: '60vh',
      data: {
        message: 'APIQL Engine installation is under progress. Please don\'t close the window'
      }
    });
    this.gatewayUrlDeploying = true;
    await this.platform.configureGateway(this.partner, this.account, this.apiQlApiName, this.apiQlApiVersion, 'https', environment.apihostname, '/v1/apiql', 443, ['POST'], false);

    Promise.resolve(this.checkIfGatewayURLExists().then(response => {
      this.gatewayUrlExists = true;
      this.componentLoading = false;
      this.gatewayUrlDeploying = false;
      loaderDialog.close();
    }, error => {
      this.platform.openSnackBar('Error while installing the APIQL Engine. Please try again after sometime.', 'Error', {
        duration: 7000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
      this.gatewayUrlExists = false;
      this.componentLoading = false;
      this.gatewayUrlDeploying = false;
      loaderDialog.close();
    }));
  }

}
